var infotecEGuideBar = (function ($, Mustache, i18n, window, document) {

    'use strict';

	function initTemplate(templatePath, appendToSelector, templateData, cb) {
    /*$.ajax({
      url: templatePath
      , global: false
      , dataType: "text"
      , async: true
      , success: function success(data, textStatusAjax, jqXHRAjax) {
        var template = data;
  			(function loadInfotecHeader() {
                  var rendered;
  				if ($(appendToSelector).length && template !== null) {
  					rendered = Mustache.render(template, {
  						equide_menu_items: {}
  					});
  					$(appendToSelector).append(rendered).find("#header-infotec [data-i18n]").i18n();
  					cb();
  				} else {
  					setTimeout(loadInfotecHeader, 100);
  				}
  			}());
      }
      , error: function fail() {
        console.log("ERROR")
      }
    });*/


		$.ajax({
			type: "GET",
			url: templatePath,
			dataType: "text",
			async: true
		}).done(function (data) {
			var template = data;
			(function loadInfotecHeader() {
                var rendered;
				if ($(appendToSelector).length && template !== null) {
					rendered = Mustache.render(template, {
						equide_menu_items: {}
					});
					$(appendToSelector).append(rendered).find("#header-infotec [data-i18n]").i18n();
					cb();
				} else {
					setTimeout(loadInfotecHeader, 100);
				}
			}());
		});
	}

	function readAjax(url, cb, type) {
		var done_cb = cb;
		$.ajax({
			type: "GET",
			url: url,
			dataType: type === undefined ? "xml" : type,
			async: true
		}).done(function (data) {
			done_cb(data);
		});
	}

	function readSearchXmlData(url, dataSelector, cb) {
		var resultData;
		readAjax(url, function (xml) {
			resultData = [];
			$(xml).find(dataSelector).each(function () {
				var resultRow = {};
				$.each(this.attributes, function () {
					resultRow[this.name] = this.value;
				});
				resultData.push(resultRow);
			});
			cb(resultData);
		});
	}

	function readTemplateData(uiTranslationDataUrl, uiLang, sommaireXmlDataUrl, dataSelector, cb) {
		var resultData = null, uiTranslationDataLoaded = false;

		// Read summary data
		readAjax(sommaireXmlDataUrl, function (xml) {
			resultData = [];
			$(xml).find(dataSelector).each(function () {
				var resultRow = {};
				$.each($(this).find(' > *'), function () {
					var tagName = $(this).get(0).tagName;
					switch (tagName) {
                    case 'name':
						resultRow[$(this).get(0).tagName] = $(this).text();
						break;
                    case 'topicref':
						$.each(this.attributes, function () {
							resultRow[tagName + '_' + this.name] = this.value;
						});
						break;
					}
				});
				resultData.push(resultRow);
			});
		});

		// Read ui translation data and append to already loaded ressources
		readAjax(uiTranslationDataUrl, function (json) {
			uiTranslationDataLoaded = true;
			i18n.addResources(uiLang, 'translation', json);

		}, 'json');

		// Wait data to be loaded then trigger callback
		(function wait() {
			if (resultData !== null && uiTranslationDataLoaded !== false) {
				cb({summary: resultData});
			} else {
				setTimeout(wait, 100);
			}
		}());
	}

	function initPdf(vehiculeXmlDataUrl, pdfsBasePath, lang) {
		var pdfFileName = null;
		readAjax(vehiculeXmlDataUrl, function (xml) {
			var pdfddb = $(xml).find('pdfddb[lang="' + lang + '"]');
			pdfFileName = pdfddb.text();
		});

		$('#eguide_pdf').on('click', function () {
			window.open(pdfsBasePath + pdfFileName, '_blank');
		});
	}

	function initSearch(rechercheXmlDataUrl) {
		autocompleteSearch.init(rechercheXmlDataUrl);
	}

	var me = {};

	me.init = function (templatePath, appendToSelector, uiTranslationDataUrl, uiLang, sommaireXmlDataUrl, rechercheXmlDataUrl, vehiculeXmlDataUrl, pdfsBasePath, lang) {
		$(document).ready(function () {
			//readTemplateData(uiTranslationDataUrl + '/' + uiLang + '/translation.json', uiLang, sommaireXmlDataUrl, 'liste > item', function (templateData) {
				//initTemplate(templatePath, appendToSelector, templateData, function () {
					initSearch(rechercheXmlDataUrl);
					initPdf(vehiculeXmlDataUrl, pdfsBasePath, lang);
				//});
			//});
		});
	};
	return me;
}(jQuery, Mustache, i18n, window, document));

infotecEGuideBar.goToHomePage = function() {
	navigationWeb.index = 0;
	navigationWeb.loadPageFromListSummary(navigationWeb.index);
}
